<template>
  <div class="mb-6">
    <vs-card>
      <div class="filtroConsolidado vx-row px-2 py-1">
        <div class="vx-col lg:w-1/4 w-full mt-3">
          <label for="Nome" class="labelFiltro">Nome</label>
          <div class="vx-col sm:flex gap-4 w-full mt-2">
            <div class="vx-col relative flex gap-4 w-full">
              <vs-input
                icon="search"
                placeholder="Nome"
                id="Nome"
                name="Nome"
                v-model="form.name"
                class="w-full sm:mb-0 mb-3"
              />
            </div>
          </div>
        </div>
        <div class="vx-col lg:w-1/4 w-full mt-3">
          <label for="CPF" class="labelFiltro">CPF</label>
          <div class="vx-col sm:flex gap-4 w-full mt-2">
            <div class="vx-col relative flex gap-4 w-full">
              <vs-input
                icon="search"
                placeholder="CPF"
                id="CPF"
                name="CPF"
                v-model="form.cpf"
                class="w-full sm:mb-0 mb-3"
                v-mask="['###.###.###-##', '##.###.###/####-##']"
              />
            </div>
          </div>
        </div>
        <div class="vx-col lg:w-1/4 w-full mt-3">
          <label for="Email" class="labelFiltro">Email</label>
          <div class="vx-col sm:flex gap-4 w-full mt-2">
            <div class="vx-col relative flex gap-4 w-full">
              <vs-input
                icon="search"
                placeholder="Email"
                id="Email"
                name="Email"
                v-model="form.email"
                class="w-full sm:mb-0 mb-3"
              />
            </div>
          </div>
        </div>
        <div class="vx-col lg:w-1/4 w-full mt-3">
          <label for="Status" class="labelFiltro">Status</label>
          <div class="vx-col sm:flex gap-4 w-full mt-2">
            <div class="vx-col relative flex gap-4 w-full">
              <v-select
                class="w-full mb-3"
                :options="statusOptions"
                icon="search"
                name="Status"
                id="Status"
                placeholder="Status"
                v-model="form.status"
                :reduce="(option) => option.value"
              />
            </div>
          </div>
        </div>
        <div class="vx-col lg:w-1/4 w-full mt-3">
          <label for="Tipo de empresa" class="labelFiltro"
            >Tipo de Empresa</label
          >
          <div class="vx-col sm:flex gap-4 w-full mt-2">
            <div class="vx-col relative flex gap-4 w-full">
              <v-select
                class="w-full mb-3"
                :options="companyTypeOptions"
                icon="search"
                name="Tipo de empresa"
                id="Tipo de empresa"
                placeholder="Tipo de empresa"
                v-model="form.companyType"
                @input="getCompaniesOptions()"
                :reduce="(option) => option.value"
              />
            </div>
          </div>
        </div>
        <div class="vx-col lg:w-1/4 w-full mt-3">
          <label for="Empresa" class="labelFiltro">Empresa</label>
          <div class="vx-col sm:flex gap-4 w-full mt-2">
            <div class="vx-col relative flex gap-4 w-full">
              <v-select
                class="w-full mb-3"
                :options="companiesOptions"
                icon="search"
                name="Empresa"
                id="Empresa"
                placeholder="Empresa"
                v-model="form.companies"
                multiple
                :reduce="(option) => option.id"
                :closeOnSelect="false"
              >
                <template #no-options> Selecione um Tipo de Empresa</template>
              </v-select>
            </div>
          </div>
        </div>
        <div class="vx-col lg:w-1/4 w-full mt-3">
          <label for="Perfil" class="labelFiltro">Perfil</label>
          <div class="vx-col sm:flex gap-4 w-full mt-2">
            <div class="vx-col relative flex gap-4 w-full">
              <v-select
                class="w-full mb-3"
                :options="profilesOptions"
                icon="search"
                name="Perfil"
                id="Perfil"
                placeholder="Perfil"
                v-model="form.profiles"
                multiple
                :reduce="(option) => option.id"
                :closeOnSelect="false"
              />
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <br style="clear: both" />
        <vs-row class="flex items-end justify-end p-1">
          <div class="bg-white mr-3 mb-2">
            <vs-button
              v-if="$can($actionsDefault.Exportar, subjectPermission)"
              color="success"
              type="border"
              icon-pack="feather"
              icon="icon-download"
              icon-after
              @click="exportXls"
            >
              Exportar
            </vs-button>
          </div>
          <vs-button
            data-testId="search-button"
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="mr-3 mb-2"
            @click="submit"
            >Buscar
          </vs-button>
          <vs-button
            data-testId="clear-button"
            @click="reset"
            color="danger"
            type="gradient"
            icon-pack="feather"
            icon="icon-trash-2"
            class="mb-2"
          ></vs-button>
        </vs-row>
      </div>
    </vs-card>
  </div>
</template>

<script>
import reportsApi from '@/services/reports.api';
import vSelect from 'vue-select';
import profileApi from '../../services/profile.api';
import notify from '../../utils/notify';

const COMPANY_TYPE_VALUES = {
  BP_SEG: 'bpseg',
  BROKER: 'broker',
  CONSULTANCY: 'consultancy',
  COVENANT: 'covenant',
};

export default {
  name: 'UsersFilter',
  components: {
    'v-select': vSelect,
  },
  props: {},
  data() {
    return {
      companyId: 118,
      companyTypeOptions: [
        { label: 'Corretora', value: COMPANY_TYPE_VALUES.BROKER },
        { label: 'Assessoria', value: COMPANY_TYPE_VALUES.CONSULTANCY },
        { label: 'Convênio', value: COMPANY_TYPE_VALUES.COVENANT },
      ],
      companiesOptions: [],
      profilesOptions: [],
      statusOptions: [
        { label: 'Ativo', value: 'active' },
        { label: 'Inativo', value: 'inactive' },
      ],
      form: this.getDefaultForm(),
    };
  },
  created() {
    this.getProfilesOptions();
  },
  methods: {
    getDefaultForm() {
      return {
        companyType: null,
        companies: [],
        status: null,
        profiles: [],
        cpf: '',
        name: '',
        email: '',
      };
    },
    reset() {
      this.form = this.getDefaultForm();
      this.$emit('submit', this.form);
    },
    submit() {
      this.$emit('submit', this.form);
    },
    exportXls() {
      this.$emit('export', this.form);
    },
    getCompaniesOptions() {
      if (
        !this.form.companyType ||
        this.form.companyType === COMPANY_TYPE_VALUES.BP_SEG
      ) {
        this.companiesOptions = [];
        this.form.companies = [];
        return;
      }
      reportsApi
        .getCompaniesByTypeOptions(this.form.companyType)
        .then((response) => {
          this.companiesOptions = response;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async getProfilesOptions() {
      profileApi
        .listProfilesByHierarchy()
        .then((response) => {
          this.profilesOptions = response.map((profile) => ({
            id: profile.id,
            label: profile.name,
          }));
        })
        .catch(() => {
          notify.notifyFail(this.$vs, 'Erro ao buscar perfis');
        });
    },
  },
};
</script>

<style scoped></style>
